import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ReceivedDigitalConsignmentDto} from '|api/sad';
import {SectionComponent} from '@icz/angular-essentials';
import {EmailMetadataPreviewComponent} from '|shared';
import {FormFieldComponent, IczFormContainerDirective, IczFormGroup} from '@icz/angular-form-elements';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'icz-delivery-info-email',
  templateUrl: './delivery-info-email.component.html',
  styleUrls: ['./delivery-info-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionComponent, EmailMetadataPreviewComponent, FormFieldComponent, ReactiveFormsModule, IczFormContainerDirective]
})
export class DeliveryInfoEmailComponent {
  @Input({required: true})
  consignment!: ReceivedDigitalConsignmentDto;
  @Input()
  form: Nullable<IczFormGroup>;
}
